// InvQtyActions.jsx — the card under the scan box in Add Inventory / Cycle Count / Stock Take.
//
// Shows the item just scanned and its count in an editable box. Change the number and the card asks what to do with
// it: "Set count to N" (N becomes the count) or "Add N" (N is added to the count). Nothing is saved until one is chosen.
import React, { useEffect, useState } from 'react';

const card = { margin: '8px 12px 0', background: '#fff', border: '1px solid #bfdbfe', borderRadius: 10,
               padding: '10px 14px', boxShadow: '0 1px 3px rgba(0,0,0,.06)' };
const btn  = (primary, dis) => ({ flex: 1, padding: '11px 10px', borderRadius: 8, fontSize: 14, fontWeight: 700,
                                  cursor: dis ? 'not-allowed' : 'pointer', opacity: dis ? .5 : 1,
                                  border: primary ? 'none' : '1px solid #1e3a5f',
                                  background: primary ? '#1e3a5f' : '#fff', color: primary ? '#fff' : '#1e3a5f' });

export default function InvQtyActions({ item, count, busy, onApply }) {
    const [draft, setDraft] = useState(String(count));
    // a new scan, or a count that changed underneath, resets the box to the real count
    useEffect(() => { setDraft(String(count)); }, [item?.sku, count]);
    if (!item) return null;

    const n       = /^\d{1,5}$/.test(draft.trim()) ? parseInt(draft.trim(), 10) : null;
    const changed = draft.trim() !== String(count);
    const canSet  = n !== null && changed && !busy;
    const canAdd  = n !== null && n >= 1 && !busy;

    return (
        <div style={card} data-inv-qty>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center' }}>
                <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', letterSpacing: .5 }}>LAST SCANNED</div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.sku}</div>
                    {item.title && <div style={{ fontSize: 11, color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.title}</div>}
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 2 }}>Qty</div>
                    <input
                        type="text" inputMode="numeric" pattern="[0-9]*"
                        value={draft}
                        onChange={e => setDraft(e.target.value.replace(/[^0-9]/g, '').slice(0, 5))}
                        onFocus={e => e.target.select()}
                        aria-label="Quantity"
                        style={{ width: 84, fontSize: 22, fontWeight: 800, textAlign: 'center', color: '#1e3a5f',
                                 padding: '6px 4px', border: `2px solid ${changed ? '#1e3a5f' : '#d1d5db'}`,
                                 borderRadius: 8, outline: 'none', background: changed ? '#f0f4ff' : '#fff' }}
                    />
                </div>
            </div>
            {changed ? (
                <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 12, color: '#374151', marginBottom: 6 }}>
                        Current count is {count}. What should {draft.trim() === '' ? 'this' : draft.trim()} do?
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <button type="button" style={btn(true, !canSet)} disabled={!canSet}
                                onClick={() => onApply('set', n)}>Set count to {n ?? '…'}</button>
                        <button type="button" style={btn(false, !canAdd)} disabled={!canAdd}
                                onClick={() => onApply('add', n)}>Add {n ?? '…'}{canAdd ? ` → ${count + n}` : ''}</button>
                    </div>
                    <button type="button" onClick={() => setDraft(String(count))}
                            style={{ marginTop: 8, background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer', padding: 0 }}>
                        Cancel change
                    </button>
                </div>
            ) : (
                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>
                    Scan the next item, or change the quantity above.
                </div>
            )}
        </div>
    );
}
